import React from 'react';

import { AppQueryClient, createAppQueryClient } from '@helpers/query/Client';
import { setupAppQueryEnvironment } from '@helpers/query/Environment';
import { QueryClientProvider } from '@tanstack/react-query';

export type AppQueryProviderProps = React.PropsWithChildren<{
  /** Optional client override for tests or isolated integration surfaces. */
  client?: AppQueryClient;
}>;

export function AppQueryProvider({ children, client }: AppQueryProviderProps) {
  const [queryClient] = React.useState(() => client ?? createAppQueryClient());

  React.useEffect(() => setupAppQueryEnvironment(), []);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
